module.exports = __webpack_public_path__ + "img/DontRun.2cca9b3b.png";